import { AUTH_BASE_URL } from '../config/api';

const API_BASE_URL = AUTH_BASE_URL;

// Upload a single file
export const uploadFile = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await fetch(`${API_BASE_URL}/api/files/upload`, {
    method: 'POST',
    credentials: 'include',
    body: formData,
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Upload failed' }));
    throw new Error(error.message || 'Failed to upload file');
  }

  return response.json();
};

// Upload multiple files
export const uploadFiles = async (files) => {
  const formData = new FormData();
  Array.from(files).forEach((file, index) => {
    formData.append(`files`, file);
  });

  const response = await fetch(`${API_BASE_URL}/api/files/upload-multiple`, {
    method: 'POST',
    credentials: 'include',
    body: formData,
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Upload failed' }));
    throw new Error(error.message || 'Failed to upload files');
  }

  return response.json();
};

// Get uploaded file info
export const getFileInfo = async (fileId) => {
  const response = await fetch(`${API_BASE_URL}/api/files/${fileId}`, {
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Failed to get file info');
  }

  return response.json();
};

// Delete uploaded file
export const deleteFile = async (fileId) => {
  const response = await fetch(`${API_BASE_URL}/api/files/${fileId}`, {
    method: 'DELETE',
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Failed to delete file');
  }

  return response.json();
};

// Get user's uploaded files
export const getUserFiles = async () => {
  const response = await fetch(`${API_BASE_URL}/api/files`, {
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Failed to get user files');
  }

  return response.json();
};

// Extract text from document (OCR/text extraction)
export const extractTextFromFile = async (fileId) => {
  const response = await fetch(`${API_BASE_URL}/api/files/${fileId}/extract-text`, {
    method: 'POST',
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Failed to extract text from file');
  }

  return response.json();
};

// Process file with AI (vision/document analysis)
export const processFileWithAI = async (fileId, prompt, modelId) => {
  const response = await fetch(`${API_BASE_URL}/api/files/${fileId}/process`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({
      prompt,
      modelId,
    }),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Processing failed' }));
    throw new Error(error.message || 'Failed to process file');
  }

  return response.json();
};